import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import ArgumentDuplicationSwitches from '../ArgumentDuplicationSwitches';
import { BudgetBys } from 'business/constants';

export type FilterConfigT = {
    resource: boolean;
    section: boolean;
    budget: boolean;
};

type Props = {
    filterValues: FilterConfigT;
    setFilterValues: DispatchState<FilterConfigT>;
    budgetProposals: BudgetProposalT[];
    resource?: string;
    by: BudgetBys;
};

export default function ThirdDuplicateArgumentsStep({
    filterValues,
    setFilterValues,
    budgetProposals,
    resource,
    by,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    return (
        <>
            <Typography variant="h4" sx={{ paddingBottom: '1.5em' }}>
                {t('adminBudgetSpace.duplicateArguments.title')}
            </Typography>
            <Typography sx={{ paddingBottom: '1.5em' }}>
                {t('adminBudgetSpace.duplicateArguments.configText')}
            </Typography>
            <ArgumentDuplicationSwitches
                resource={resource!}
                setFilterValues={setFilterValues}
                filterValues={filterValues}
                budgetProposals={budgetProposals}
                by={by}
            />
        </>
    );
}
